export default "/images/foods_and_beverages_provided_sm.jpg?f827be3d550b240109a7b340e4373c99";